
<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <!-- ───── Avatar (left column) ───── -->
      <div class="vx-col md:w-1/3 w-full text-center md:text-left">
        <div class="flex flex-col items-center md:items-start">
          <vs-avatar
            v-if="imgsrc && imgsrc !== 'null'"
            :src="imgsrc"
            size="120px"
            class="mb-4"
          />
          <vs-avatar
            v-else
            icon="icon-user"
            icon-pack="feather"
            size="120px"
            class="mb-4"
          />
          <div class="flex flex-wrap justify-center md:justify-start">
            <vs-button
              size="small"
              class="mr-2 mb-2"
              icon-pack="feather"
              icon="icon-upload"
              @click="$refs.file.click()"
            >Upload</vs-button>
            <vs-button
              size="small"
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              class="mb-2"
              @click="removeavatar()"
            >Remove</vs-button>
          </div>
          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" hidden />
          <p class="text-xs text-grey mt-2 max-w-xs">
            Square image, ideally 256×256 px. PNG or JPG.
          </p>
        </div>
      </div>

      <!-- ───── Identity form (right column) ───── -->
      <div class="vx-col md:w-2/3 w-full">
        <h5 class="mb-4">Account details</h5>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input
              label="Username"
              v-model="dataUsername"
              class="w-full"
              name="username"
              v-validate="'required|alpha'"
              placeholder="Username"
            />
            <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-4 md:mt-0">
            <vs-input
              label="Email"
              v-model="dataEmail"
              class="w-full"
              name="email"
              placeholder="Email"
              v-validate="'required|email'"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
        </div>

        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input
              label="First name"
              v-model="dataFirstname"
              class="w-full"
              name="firstname"
              placeholder="First name"
            />
            <span class="text-danger text-sm" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-4 md:mt-0">
            <vs-input
              label="Last name"
              v-model="dataLastname"
              class="w-full"
              name="lastname"
              placeholder="Last name"
            />
          </div>
        </div>

        <div class="mt-8 flex justify-end">
          <vs-button
            color="success"
            icon-pack="feather"
            icon="icon-save"
            @click="save_changes(false)"
            :disabled="!validateForm"
          >Save changes</vs-button>
        </div>

        <p class="text-xs text-grey mt-6">
          Need to change your password or set up two-factor authentication?
          See the <strong>Security</strong> tab.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js'
import moment from 'moment'
import moduleDataListUsers from '@/store/configurations-users/moduleDataList.js'
import DisableAutocomplete from 'vue-disable-autocomplete'

export default {
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isMounted: false,
      // Data Sidebar
      buttonSubmitOpen: false,
      state: {},
      dataUsername: '',
      dataFirstname: '',
      dataLastname: '',
      dataEmail: '',
      dataNewPassword: '',
      dataConfirmPassword: '',
      file: '',
      imgsrc: 'null'
    }
  },
  computed: {
    activeUserInfo () {
      const date = moment(localStorage.getItem('login-date'))
      const newdate = moment(date.add(23, 'hours')).format('DD-MM-YYYY HH:mm:ss')
      const objectls = {
        date: `Token Life: ${  newdate}`,
        username: localStorage.getItem('login-username'),
        email: localStorage.getItem('login-email'),
        avatar: localStorage.getItem('login-avatar')
      }
      this.objectuser = objectls
      this.imgsrc = localStorage.getItem('login-avatar')
      return objectls
    },
    validateForm () {
      return !this.errors.any() && this.dataUsername && this.dataEmail
    },
    routerTransitionLocal: {
      get () {
        return this.routerTransition
      }
    }
  },
  methods: {
    handleFileUpload () {
      this.$vs.loading()
      this.file = this.$refs.file.files[0]
      try {
        this.submitFile()
      } catch (error) {}
      this.$vs.notify({
        color: 'success',
        title: 'Avatar',
        text: 'Avatar Uploaded, Save to Refresh!'
      })
    },
    submitFile () {
      /*
                Initialize the form data
            */
      const formData = new FormData()

      /*
                Add the form data we need to submit
            */
      formData.append('file', this.file)

      /*
          Make the request to the POST /single-file URL
        */
      axios
        .post(`/avatar/${  localStorage.getItem('login-id')}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          console.log(response.data)
          localStorage.setItem('login-avatar', response.data)
          this.imgsrc = response.data
          this.$vs.loading.close()
        })
        .catch(function () {
          console.log('FAILURE!!')
        })
    },
    removeavatar () {
      const obj = {
        id: localStorage.getItem('login-id'),
        avatarsrc: null
      }
      if (!moduleDataListUsers.isRegistered) {
        this.$store.registerModule('dataListUsers', moduleDataListUsers)
        moduleDataListUsers.isRegistered = true
      }
      console.log(obj)
      this.$store.dispatch('dataListUsers/updateItem', obj).catch(err => {
        console.error(err)
      })
      localStorage.removeItem('login-avatar')
      this.activeUserInfo.avatar = 'null'
      this.$vs.notify({
        color: 'success',
        title: 'Avatar',
        text: 'Avatar Removed!'
      })
    },
    async getUserData () {
      this.$vs.loading()
      axios
        .get(`/user/data/${  localStorage.getItem('login-id')}`)
        .then(response => {
          this.dataUsername = response.data.username
          this.dataFirstname = response.data.firstname
          this.dataLastname = response.data.lastname
          this.dataEmail = response.data.email
          this.imgsrc = localStorage.getItem('login-avatar')
          this.$vs.loading.close()
        })
    },
    successUpload () {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Avatar Uploaded!'
      })
    },
    save_changes () {
      //FINAL
      this.$validator.validateAll().then(result => {
        // Le mot de passe se change dans l'onglet Security (/api/profile/password
        // et ses règles) : /api/users/update pour soi-même n'accepte que les
        // champs de profil.
        const obj = {
          id: localStorage.getItem('login-id'),
          username: this.dataUsername,
          firstname: this.dataFirstname,
          lastname: this.dataLastname,
          email: this.dataEmail
        }
        if (!moduleDataListUsers.isRegistered) {
          this.$store.registerModule('dataListUsers', moduleDataListUsers)
          moduleDataListUsers.isRegistered = true
        }
        this.$store.dispatch('dataListUsers/updateItem', obj).catch(err => {
          console.error(err)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Profil Updated!'
          })
          location.reload()
        })
      })
    }
  },
  mounted () {
    this.isMounted = true
  },
  created () {
    this.getUserData()
  }
}
</script>

